import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IAutomation } from 'types/income';
import { TableDataResponse } from 'types/general';
import { AutomationsFilters, RuleValues } from './automations.types';
import { convertValuesToRule } from './automations.converters';

interface GetAutomations {
  filters: Partial<AutomationsFilters>;
}

interface GetAutomation {
  automationId: string;
}

interface CreateAutomation {
  name: string;
  enabled: boolean;
  rule: RuleValues;
  startDate: string | null;
  endDate: string | null;
}

interface UpdateAutomation {
  automationId: string;
  data: Partial<CreateAutomation>;
}

interface ExecuteAutomation {
  automationId: string;
}

interface RemoveAutomation {
  automationId: string;
}

export const loaders = {
  getAutomations: ({ filters }: GetAutomations) => {
    return api<TableDataResponse<IAutomation>>({
      url: Endpoints.clientAdmin.automations.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
      },
    });
  },
  getAutomation: ({ automationId }: GetAutomation) => {
    return api<IAutomation>({
      url: Endpoints.clientAdmin.automations.byId.root.replace(
        ':automationId',
        automationId,
      ),
    });
  },
  createAutomation: ({
    name,
    enabled,
    startDate,
    endDate,
    rule,
  }: CreateAutomation) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.automations.root,
      data: {
        name,
        enabled,
        startDate,
        endDate,
        rule: convertValuesToRule(rule),
      },
      method: 'post',
    });
  },
  updateAutomation: ({ automationId, data }: UpdateAutomation) => {
    return api({
      url: Endpoints.clientAdmin.automations.byId.root.replace(
        ':automationId',
        automationId,
      ),
      data: {
        ...data,
        rule: data.rule ? convertValuesToRule(data.rule) : undefined,
      },
      method: 'patch',
    });
  },
  executeAutomation: ({ automationId }: ExecuteAutomation) => {
    return api<{ subjectCount: number }>({
      url: Endpoints.clientAdmin.automations.byId.execute.replace(
        ':automationId',
        automationId,
      ),
      method: 'post',
    });
  },
  removeAutomation: ({ automationId }: RemoveAutomation) => {
    return api({
      url: Endpoints.clientAdmin.automations.byId.root.replace(
        ':automationId',
        automationId,
      ),
      method: 'delete',
    });
  },
};
